import { ApiViewModelTransformer } from './src/ApiViewModelTransformer.js';
window.customElements.define('api-view-model-transformer', ApiViewModelTransformer);
